import React, { PureComponent } from 'react';
import { Link } from 'react-router';
import RelativeDate from '../../components/RelativeDate';
import { BASE_URL } from '../../config';

export default class ComponentIndexRow extends PureComponent {
  static propTypes = {
    // TODO
  }

  render() {
    const { component: { name, fullName, description, version, publishTime } } = this.props;

    return (
      <div className="row table-row">
        <div className="col-2">
          <Link to={`${BASE_URL}/${name}/latest/index.html`}>{name}</Link><br />
        </div>
        <div className="col-6">
          <div style={{ paddingRight: 16 }}>
            {description}
            &nbsp;
          </div>
        </div>
        <div className="col-2">
          <a href={`https://www.npmjs.com/package/${fullName}`}>
            {version}
          </a>
          &nbsp;
          {
            publishTime ? (
              <span>
                (<RelativeDate iso={publishTime} />)
              </span>
            ) : null
          }

        </div>
      </div>
    );
  }
};



// WEBPACK FOOTER //
// ./src/components/ComponentIndexPage/ComponentIndexRow.jsx